const SECRET_KEY = 'hgdcr';

function xorCipher(bytes) {
  const keyBytes = new TextEncoder().encode(SECRET_KEY);
  return bytes.map((byte, idx) => byte ^ keyBytes[idx % keyBytes.length]);
}

export function encode(input) {
  const inputBytes = new TextEncoder().encode(input);
  const encodedBytes = xorCipher(inputBytes);
  const base64 = btoa(String.fromCharCode(...encodedBytes));
  // Convert to URL-safe Base64 and strip padding for shorter output
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function decode(encodedInput) {
  // Accept both URL-safe and standard Base64; pad if necessary
  let base64 = encodedInput.replace(/-/g, '+').replace(/_/g, '/');
  const pad = base64.length % 4;
  if (pad) base64 += '='.repeat(4 - pad);
  const byteString = atob(base64);
  const decodedBytes = Array.from(byteString, (char) => char.charCodeAt(0));
  const originalBytes = xorCipher(decodedBytes);
  return new TextDecoder().decode(new Uint8Array(originalBytes));
}
